export default __webpack_public_path__ + "static/media/overallDescriptionThumbnail.c8a7b0d7.svg";